import { useEffect, useRef } from 'react';

export function useScrollProgress() {
  const headerRef = useRef<HTMLDivElement>(null);
  const brandingRef = useRef<HTMLDivElement>(null);
  const progressRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const header = headerRef.current;
    const branding = brandingRef.current;
    if (!header || !branding) return;

    const measure = () => {
      header.style.top = `-${branding.offsetHeight}px`;
    };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(branding);

    let ticking = false;
    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          if (progressRef.current) {
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const pct = docHeight > 0 ? Math.min(100, (window.scrollY / docHeight) * 100) : 0;
            progressRef.current.style.width = `${pct}%`;
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => {
      window.removeEventListener('scroll', onScroll);
      ro.disconnect();
    };
  }, []);

  return { headerRef, brandingRef, progressRef };
}
